<template>
  <div class="bg-echoes-background-gray border-echoes-border-light overflow-hidden shadow rounded-xl">
    <div class="p-5 h-full flex flex-col justify-center">
      <div class="flex items-center">
        <div class="flex-shrink-0">
          <slot name="icon"></slot>
        </div>
        <div class="ml-5 w-full flex-1">
          <dl class="w-full">
            <dt class="text-sm font-medium text-white/80 truncate">
              <slot name="title"></slot>
            </dt>
            <dd class="flex w-full">
              <div class="text-2xl font-semibold text-white w-full">
                <slot name="value"></slot>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>